export const blogArticleInitialState = {
  content: {
    data: {},
    slug: "",
    isError: null,
    isLoading: false,
    isDataLoaded: false,
  },
};
